import React, { useEffect, useState } from 'react';
import Note from './Editor';
import { Box, FormControlLabel, Typography } from '@mui/material';
// import { CKEditor } from './Editor';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import debounce from 'lodash.debounce';
import addToWatchlist from '../../../../lib/watchlist/_addToWatchlist';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import * as send from '../../../../lib/analytics/send';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '10px',
  },
}));

const label = { inputProps: { 'aria-label': 'Autosave Checkbox' } };

const Icon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
}));

const CheckedIcon = styled(Icon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: 'rgb(67, 65, 102)',
  },
}));

function Check(props) {
  return (
    <Checkbox
      sx={{
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      checkedIcon={<CheckedIcon />}
      icon={<Icon />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      {...props}
    />
  );
}

const WatchlistNote = ({ selectedWatchlistNotes, selectedWatchlistDesc, selectedWatchlist, tickers, accessToken, isSystemDefault, }) => {
  const [editorData, setEditorData] = useState(null);
  const [focus, setFocus] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState(null);
  const [checked, setChecked] = React.useState(true);
  const tooltopinfo = 'With the "Auto Save" function enabled, modifications made in the notes will be automatically saved. To manually save your changes, you can opt to disable the "Auto Save" feature situated at the bottom of the editor.'

  // useEffect(() => {
  //   setEditorData(selectedWatchlistNotes)
  // }, [selectedWatchlistNotes])

  const handleCheck = (event) => {
    setStatus(null);
    setChecked(event.target.checked);
  };

  const handleDataChange = (content) => {
    setEditorData(content);
  };

  function handleSave() {
    handleAddNote();
  }

  const handleAutoSave = debounce((content) => {
    setEditorData(content);
    handleAddNote(content);
  }, 777);

  const handleAddNote = async (content) => {
    const _tickers = tickers ?? []
    const _watchlist = selectedWatchlist ?? ""
    const _notes = checked ? content : editorData
    const _description = selectedWatchlistDesc ?? ""
    const _columns = null
    setLoading(true);
    await addToWatchlist(_watchlist, _tickers, _notes, _description, _columns, accessToken)
      .then(data => {
        setStatus(data?.addToWatchlist?.status === "Success" ? "Saved" : null)
        if (data?.addToWatchlist?.status === "Success") {
          setLoading(false);
          send.uevent(undefined, `${selectedWatchlist}-note-saved`);
        }
      })
      .catch(err => {
        console.log('caught it!', err);
        setLoading(false);
        throw new Error(err);
      });
  }

  return (
    <>
      <Box component="div" className="s-section note-section"
        sx={{
          // position: 'relative',
          '& .tiptap': {
            background: "#fbfbfc",
            padding: '0 .5rem 1.5rem .5rem',
            minHeight: 300, borderRadius: '0.5rem',
            border: '1px solid rgb(67 65 102 / 7%)',
            // transition: 'all 0.4s ease 0s'
          },
          // '& .tiptap:hover, .tiptap.ProseMirror-focused': {
          //   padding: '4rem .5rem 1.5rem .5rem',
          // },
          '& .tiptap.ProseMirror-focused': {
            outline: 'rgb(67 65 102 / 37%) auto 0px',
            border: '1px solid rgb(67 65 102 / 37%)', borderRadius: '0 0 0.5rem 0.5rem',
          },
          // '& .tiptap .is-empty::before': {
          //   content: 'attr(data-placeholder)',
          //   float: 'left',
          //   color: '#ced4da',
          //   pointerEvents: 'none',
          //   height: '0',
          // },
          '& .bubble-menu': {
            display: 'flex',
            backgroundColor: '#2a2d64',
            padding: '0.5rem',
            borderRadius: '0.5rem',
          },
          '& .bubble-menu button': {
            border: 'none !important',
            background: 'none !important',
            color: '#FFF !important',
            fontSize: '0.875rem !important',
            fontWeight: 600,
            padding: '0 .4rem !important',
            opacity: '0.6 !important',
            cursor: 'pointer !important',
          },
          '& .bubble-menu button:hover, .bubble-menu button.is-active': { opacity: '1', },
          '& .character-count': { position: 'absolute', bottom: '7px', left: '7px', zIndex: 7 },
          '& .note-section-menu': {
            position: 'sticky', top: '4rem', zIndex: 7,
            // position: 'absolute', top: '7px', left: '7px', zIndex: 7,
            border: '1px solid rgb(67 65 102 / 37%)', borderRadius: '0.5rem 0.5rem 0 0', borderBottom: 0,
            visibility: focus ? 'visible' : 'hidden',
            padding: .7, backgroundColor: '#fbfbfc',
            // transition: 'all .04s ease 0s'
          },
          '& .note-section-menu:hover': {
            visibility: 'visible',
          },
          '& .character-count__text': {
            visibility: focus ? 'visible' : 'hidden',
          },
          '&.note-section button': {
            fontSize: '.875rem',
            fontFamily: 'inherit',
            color: 'rgb(67, 65, 102)',
            margin: '0.1rem 0.15rem 0.2rem 0.1rem',
            border: '1px solid rgb(67 65 102 / 37%)',
            borderRadius: ' 0.3rem',
            padding: ' 0.18rem 0.4rem',
            background: 'white',
            accentColor: 'black',
            cursor: 'pointer',
          },
          '&.note-section input[type="color" i]': {
            inlineSize: '50px',
            blockSize: '23px',
            margin: '0.1rem 0.15rem 0.2rem 0.1rem',
            padding: 0,
            border: '1px solid rgb(67 65 102 / 37%)',
            borderRadius: ' 0.3rem',
            background: 'white',
            color: 'white',
            cursor: 'pointer',
            paddingInline: '2px',
            paddingBlock: 0,
          },
          '&.note-section .is-active': {
            background: '#2a2d64',
            color: '#fff',
          },
          // '& .tiptap': {
          //   marginTop: '1rem',
          // },

          '& .tiptap > * + *': {
            marginTop: '0.75em',
          },

          '& .tiptap ul, .tiptap ol': {
            padding: ' 0 1rem',
          },

          '& .tiptap a': {
            color: '#174c86',
            cursor: 'pointer',
          },

          '& .tiptap h1, .tiptap h2, .tiptap h3, .tiptap h4, .tiptap h5, .tiptap h6 ': {
            lineHeight: '1.1',
          },

          '& .tiptap code': {
            backgroundColor: 'rgba(#616161, 0.1)',
            color: '#616161',
          },

          '& .tiptap pre': {
            background: '#0D0D0D',
            color: '#FFF',
            fontFamily: "'JetBrainsMono', monospace",
            padding: '0.75rem 1rem',
            borderRadius: '0.5rem',
          },

          '& .tiptap pre code': {
            color: 'inherit',
            padding: 0,
            background: 'none',
            fontSize: '0.8rem',
          },

          '& .tiptap mark': {
            backgroundColor: ' #FAF594',
          },

          '& .tiptap img': {
            maxWidth: '100%',
            height: 'auto',
          },

          '& .tiptap blockquote': {
            paddingLeft: '1rem',
            borderLeft: '2px solid rgb(13 13 13 / 15%)',
          },

          '& .tiptap hr': {
            border: 'none',
            borderTop: '2px solid rgb(13 13 13 / 15%)',
            margin: '2rem 0',
          },
          '& .tiptap h1.is-editor-empty::before, .tiptap p.is-editor-empty::before': {
            color: '#adb5bd',
            content: 'attr(data-placeholder)',
            float: 'left',
            height: 0,
            pointerEvents: 'none',
          }
        }}>
        <Note
          data={editorData}
          selectedWatchlistNotes={selectedWatchlistNotes}
          onDataChange={handleDataChange}
          handleAutoSave={handleAutoSave}
          setFocus={setFocus}
          checked={checked}
          isSystemDefault={isSystemDefault}
          editorhead={
            <Box component="div" className="note-heading" sx={{ position: "absolute", bottom: '7px', px: .7, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%' }}>
              <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 600, color: '#434166' }}>{`Notes`}</Typography>
              {!isSystemDefault &&
                <Typography variant="caption" sx={{ color: '#595959' }}>
                  {`Auto save is turned ${checked ? 'on' : 'off'}`}
                  <LightTooltip title={tooltopinfo} arrow placement="top-start" disableInteractive>
                    <HelpRoundedIcon sx={{ fontSize: '.9rem', verticalAlign: 'middle', ml: .5 }} />
                  </LightTooltip>
                </Typography>}
            </Box>
          }
        />
      </Box>
      {!isSystemDefault &&
        <Box component="div" sx={{ mt: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <FormControlLabel
            {...label}
            control={<Check />}
            checked={checked}
            disabled={isSystemDefault}
            onChange={handleCheck}
            label="Auto save"
            sx={{ ml: '-8px', '& .MuiFormControlLabel-label': { fontSize: '.875rem', lineHeight: 1, color: 'rgb(67, 65, 102)' } }}
          />
          <LoadingButton
            size="small"
            onClick={handleSave}
            loading={loading}
            disabled={checked || isSystemDefault}
            loadingIndicator="Saving…"
            variant="text"
            sx={{
              border: '1px solid rgb(67 65 102 / 7%)',
              textTransform: 'none', background: '#fbfbfc',
            }}
          >
            <span style={{ margin: '0 17px' }}>{checked && status ? status : `Save`}</span>
          </LoadingButton>
        </Box>}
    </>
  );
}

export default (WatchlistNote)
